import { toCartesian } from "../../../noncomponents/HelperFunctions"


function Sectoren({ data, circleWidth, middleRadius, clickSelection,
  hoverSelection, connectionChains, chainSelection }){

  const sectorenDict = [
    {'name':'Drinkwater', 'color':'#648da8', 'aantal':0},
    {'name':'Industrie', 'color':'#9b9a9f', 'aantal':0},
    {'name':'Landbouw', 'color':'#c4d561', 'aantal':0},
    {'name':'Natuur', 'color':'#6cb74c', 'aantal':0},
    {'name':'Recreatie', 'color':'#deaf25', 'aantal':0},
    {'name':'Transport', 'color':'#9b9a9f', 'aantal':0},
    {'name':'Energie', 'color':'#ef7f05', 'aantal':0},
    {'name':'Wonen en werken', 'color':'#650ca1', 'aantal':0},
    {'name':'Veiligheid', 'color':'#da322b', 'aantal':0},
    {'name':'Gezondheid', 'color':'#f8ca44', 'aantal':0}
  ];

  data.forEach((row, i) => {
    if(row['typenr'] === '4'){
      sectorenDict.filter(d => d.name === row['getroffen sector/functie'])[0]['aantal'] += 1;
    }
  });

  const clickChain = (clickSelection >= 0)
    ? connectionChains[clickSelection]['chainIcons']
    : [];
  const chainChain = (chainSelection >= 0)
    ? connectionChains[chainSelection]['chainIcons']
    : [];
  const hoverChain = (hoverSelection >= 0)
    ? connectionChains[hoverSelection]['chainIcons']
    : [];


  const strokeWidth = 3;

  let currentTheta = -0.09;

  const amountOfIconsInOuterCircle = data.filter(d => d['typenr'] === '4').length;

  const donutParts = sectorenDict.map((sector,i) => {
    const thetaOffset = 0.02;

    const perimeterStep = (2*Math.PI/(amountOfIconsInOuterCircle + thetaOffset));
    const arcLength = sector['aantal'] * perimeterStep - 0.02;

    const startTheta = currentTheta + thetaOffset;
    const endTheta = startTheta + arcLength - thetaOffset;
    const outerRadius = middleRadius + 7.4*circleWidth;

    currentTheta += arcLength + thetaOffset;

    const b = toCartesian([[outerRadius, startTheta]])[0]
    const c = toCartesian([[outerRadius, endTheta]])[0]

    let opacity = 0.15;
    if(clickSelection < 0 && hoverSelection < 0){
      opacity = 1;
    }else{
      const sectorIDs = data.filter(d => d['getroffen sector/functie'] === sector['name']).map(d => d.ID);
      sectorIDs.forEach((sectorID, i) => {
        if(
          (clickChain.includes(+sectorID) && chainChain.includes(+sectorID)) ||
          hoverChain.includes(+sectorID)
        ){
          opacity = 1;
        }
      });
    }

    let fontSize = 13.5;
    if(sector['aantal'] === 1){
      fontSize = 9.5;
    }

    return (
      <g key={sector.name} className={sector.name} pointerEvents='none'
        opacity={opacity} >
        <path d={`
            M ${b[0]},${b[1]}
            A ${outerRadius},${outerRadius} 0 0,1 ${c[0]},${c[1]}
          `}
          stroke={sector['color']} strokeWidth={strokeWidth} fill='none' opacity='0.7'
          id={sector['name']}
          markerStart={"url(#circle" + sector.color + ")"}
          markerEnd={"url(#circle" + sector.color + ")"}
        />
        <text dy='-6' fontSize={fontSize} fill='#635F5D'>
          <textPath xlinkHref={'#' + sector['name']} textAnchor='middle' startOffset='50%'>
            {sector['name']}
          </textPath>
        </text>
      </g>
    )
  })

  return (
    <g className='Sectoren'>

      {donutParts}

      {/* this def is quite hacky. I don't really understand the measurements of the circlemarker  */}
      {/* <defs>
        {sectorenDict.map(sector => {
          return (
            <marker key={sector.name}
                id={"circle" + sector.color} viewBox={`0 0 ${strokeWidth} ${strokeWidth}`} refX={2} refY={2}
                markerWidth={strokeWidth} markerHeight={strokeWidth}
                orient="auto-start-reverse" fill={sector.color}>
              <circle r={strokeWidth/9} cx='2' cy='2'/>
            </marker>
          )
        })}
      </defs> */}
    </g>
  );


}

export default Sectoren;
